import { useEffect, useState } from "react";
import { SlidersHorizontal, Power } from "lucide-react";
import { PageHeader } from "@/components/common/PageHeader";
import { DataTable } from "@/components/common/DataTable";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Switch } from "@/components/ui/switch";
import { listResource, updateResource } from "@/lib/api";
import { toast } from "sonner";
import CatalogosRipsPanel from "@/components/pld/CatalogosRipsPanel";

export default function ConfiguracionNormativa() {
  const [regimenes, setRegimenes] = useState([]);
  const [obligaciones, setObligaciones] = useState([]);

  const load = () => {
    listResource("regimenes").then(setRegimenes);
    listResource("obligaciones").then(setObligaciones);
  };
  useEffect(() => { load(); }, []);

  const toggle = async (r) => {
    try {
      await updateResource("regimenes", r.id, {
        activo: !r.activo,
        estado_cumplimiento: !r.activo ? "Al corriente" : "No activado",
      });
      toast.success(`${r.nombre} ${!r.activo ? "activado" : "desactivado"}`);
      load();
    } catch (e) {
      toast.error("No se pudo actualizar el régimen");
    }
  };

  return (
    <div>
      <PageHeader title="Configuración normativa" subtitle="Motor normativo configurable — activa o desactiva regímenes y administra obligaciones" />
      <div className="p-6 md:p-8">
        <Tabs defaultValue="regimenes">
          <TabsList className="mb-4">
            <TabsTrigger value="regimenes" data-testid="tab-regimenes">Regímenes</TabsTrigger>
            <TabsTrigger value="obligaciones" data-testid="tab-obligaciones">Obligaciones</TabsTrigger>
            <TabsTrigger value="catalogos-rips" data-testid="tab-catalogos-rips">Catálogos CNBV</TabsTrigger>
          </TabsList>

          <TabsContent value="regimenes">
            <div className="mb-4 flex items-start gap-3 rounded-lg border border-slate-200 bg-white p-4 shadow-sm">
              <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary/10"><SlidersHorizontal className="h-4 w-4 text-primary" /></div>
              <p className="text-sm text-slate-600">
                SOFOM ENR es el vertical activo. La plataforma es multi-régimen: activa nuevos regímenes para habilitar sus
                obligaciones, reportes, umbrales, documentos, alertas, calendario y autoridad aplicable.
              </p>
            </div>
            <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">
              {regimenes.map((r) => (
                <div key={r.id} data-testid={`regimen-${r.id}`}
                  className={`rounded-lg border p-4 shadow-sm transition-colors ${r.activo ? "border-emerald-200 bg-emerald-50/40" : "border-slate-200 bg-white"}`}>
                  <div className="flex items-start justify-between">
                    <Power className={`h-5 w-5 ${r.activo ? "text-emerald-600" : "text-slate-300"}`} />
                    <Switch data-testid={`toggle-${r.id}`} checked={!!r.activo} onCheckedChange={() => toggle(r)} />
                  </div>
                  <p className="mt-2 font-heading text-sm font-semibold text-slate-800">{r.nombre}</p>
                  <p className="text-xs text-slate-500">{r.autoridad}</p>
                  <p className="mt-1 text-xs text-slate-400">Periodicidad: {r.periodicidad}</p>
                  <p className={`mt-2 text-xs font-medium ${r.activo ? "text-emerald-600" : "text-slate-400"}`}>{r.estado_cumplimiento}</p>
                </div>
              ))}
            </div>
          </TabsContent>

          <TabsContent value="obligaciones">
            <DataTable testid="table-obligaciones" rows={obligaciones}
              columns={[
                { key: "obligacion", label: "Obligación" }, { key: "autoridad", label: "Autoridad", kind: "badge" },
                { key: "regimen", label: "Régimen", kind: "badge" }, { key: "periodicidad", label: "Periodicidad" },
                { key: "fecha_limite", label: "Fecha límite", kind: "date" }, { key: "estatus", label: "Estatus", kind: "badge" },
              ]} emptyLabel="Sin obligaciones" />
          </TabsContent>

          <TabsContent value="catalogos-rips">
            <CatalogosRipsPanel />
          </TabsContent>
        </Tabs>
      </div>
    </div>
  );
}
